module.exports = {"title":"Немецкая волна","description":"Еще недавно от футболистов требовалось лишь хорошо выполнять свою работу на поле, но теперь нужно еще быть примером вне поля.<br />&laquo;Лента.ру&raquo; разобралась, кто самый стильный в мировом футболе","image":"http://boss.lenta.ru/img/facebook_1200x630_1.jpg","url":"http://boss.lenta.ru/","fbappid":396959934055666,"GTM":"GTM-T9BGGDT"}


//////////////////
// WEBPACK FOOTER
// ./js/meta.json
// module id = 440
// module chunks = 0